import { Fragment } from "react"
import { TeamMember, TeamMemberModal } from "components/TeamMember"
import slugify from "utilities/slugify"
import richText from "utilities/richText"
import isRichTextValid from "utilities/isRichTextValid"

export default function TeamMemberSection({ blok }) {
  const teamMembers = blok?.teamMembers ?? []

  return (
    <section>
      {blok?.title ? (
        <div className="px-6 py-12">
          <h1 className="mx-auto max-w-screen-xl text-teal-dark">{blok.title}</h1>
        </div>
      ) : null}
      <div>
        {teamMembers.map(({ group, content, members }) => (
          <Fragment key={group}>
            <div className="px-6 py-9 odd:bg-stone-mid even:bg-stone-light" id={slugify(group)}>
              <div className="mx-auto max-w-screen-xl">
                <h2 className="text-teal-dark">{group}</h2>
                {isRichTextValid(content) ? <div className="max-w-3xl pt-4">{richText(content)}</div> : null}
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                  {members.map((member) => (
                    <TeamMember {...member} group={group} key={`${member.name}-${group}`} />
                  ))}
                </div>
              </div>
            </div>
            {members.map((member) =>
              isRichTextValid(member.bio) ? (
                <TeamMemberModal {...member} group={group} key={`${member.name}-${group}-modal`} />
              ) : null,
            )}
          </Fragment>
        ))}
      </div>
    </section>
  )
}
